import type { PluginExports } from 'graylog-web-plugin/plugin';

import SearchResultsFromJSON from 'data-lake/preview/storage-types/internal/SearchResultsFromJSON';
import {
  EXTERNAL_DATA_LAKE_STORAGE_TYPE_TRINO,
  EXTERNAL_DATA_LAKE_STORAGE_TYPE_ATHENA,
} from 'data-lake/preview/storage-types/external/Constants';
import ExternalDataLakePreview from 'data-lake/preview/storage-types/external/ExternalDataLakePreview';
import AwsSecurityIcon from 'data-lake/preview/storage-types/external/aws-security/AwsSecurityIcon';
import { EXTERNAL_DATA_LAKE_QUERY_TYPE, EXTERNAL_DATA_LAKE_SEARCH_TYPE } from 'data-lake/preview/Constants';
import type { ExternalDataLakeFormValues } from 'data-lake/preview/storage-types/external/Types';
import ExternalFormFieldsComponent from 'data-lake/components/DataLakeActionModals/ExternalFormFieldsComponent';

const externalDataLakeExport: PluginExports = {
  searchTypes: [
    {
      type: EXTERNAL_DATA_LAKE_SEARCH_TYPE,
      handler: SearchResultsFromJSON,
      defaults: {},
    },
  ],
  dataLakeStorageTypes: [
    {
      icon: AwsSecurityIcon,
      previewComponent: ExternalDataLakePreview,
      retrievalFormFieldsComponent: ExternalFormFieldsComponent,
      searchType: EXTERNAL_DATA_LAKE_SEARCH_TYPE,
      queryType: EXTERNAL_DATA_LAKE_QUERY_TYPE,
      storageType: EXTERNAL_DATA_LAKE_STORAGE_TYPE_TRINO,
      extraValidations: {
        fieldFilters: (formValues: ExternalDataLakeFormValues) => {
          if (!formValues.table) return 'You have to select a table first to operate with field filters';

          return undefined;
        },
      },
    },
    {
      icon: AwsSecurityIcon,
      previewComponent: ExternalDataLakePreview,
      retrievalFormFieldsComponent: ExternalFormFieldsComponent,
      searchType: EXTERNAL_DATA_LAKE_SEARCH_TYPE,
      queryType: EXTERNAL_DATA_LAKE_QUERY_TYPE,
      storageType: EXTERNAL_DATA_LAKE_STORAGE_TYPE_ATHENA,
      extraValidations: {
        fieldFilters: (formValues: ExternalDataLakeFormValues) => {
          if (!formValues.table) return 'You have to select a table first to operate with field filters';

          return undefined;
        },
      },
    },
  ],
};

export default externalDataLakeExport;
